module.exports = __webpack_public_path__ + "static/img/noSwiperRoom.1636833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/noSwiperRoom.png
// module id = E+Lq
// module chunks = 3